export default __webpack_public_path__ + "static/media/outside.0ead3395.jpg";